import {
    DEALERDELETEUSERMASTER_SUCCESS,
    DEALERDELETEUSERMASTER_FAILED,
    RESET_DEALERDELETEUSERMASTER,
    LOADING_DEALERDELETEUSERMASTER,
    NETWORK_ERROR_DEALERDELETEUSERMASTER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerDeleteUserMaster = () => {
    return { type: RESET_DEALERDELETEUSERMASTER };
};

const dealerDeleteUserMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERDELETEUSERMASTER });
    await dealerServices
        .post("getDelete", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerDeleteUserMastersuccess(res.data));
                    break;
                default:
                    dispatch(dealerDeleteUserMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERDELETEUSERMASTER,
                payload: err
            });
        });
};
function dealerDeleteUserMastersuccess(data) {
    return {
        type: DEALERDELETEUSERMASTER_SUCCESS,
        payload: data
    };
}
function dealerDeleteUserMasterFailed(data) {
    return {
        type: DEALERDELETEUSERMASTER_FAILED,
        payload: data
    };
}

export { resetDealerDeleteUserMaster, dealerDeleteUserMaster };
